import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" RTL.hu címlap ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rtl_logo = _resolveComponent("rtl-logo")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_container = _resolveComponent("container")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["rtl-nav", {
      [`rtl-nav--${_ctx.position}`]: _ctx.position,
      'rtl-nav--pinned-top': _ctx.isPinnedTop,
      'rtl-nav--pinned-bottom': _ctx.isPinnedBottom,
    }])
  }, [
    _createVNode(_component_container, { class: "rtl-nav__container" }, {
      default: _withCtx(() => [
        _createElementVNode("a", { href: _ctx.rtlUrl }, [
          _createVNode(_component_rtl_logo, { class: "rtl-nav__logo" })
        ], 8, _hoisted_1),
        _createElementVNode("a", {
          class: "rtl-nav__link",
          href: _ctx.rtlUrl
        }, [
          _hoisted_3,
          _createVNode(_component_arrow_right)
        ], 8, _hoisted_2)
      ]),
      _: 1
    })
  ], 2))
}